





































































































































































































































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getInfo, UnitSnapshotData, emptyUnitSnapshot,
  UnitSnapshotHandleData, emptyUnitSnapshotHandle,
  postHandle, UnitSnapshotAuditData,
  emptyUnitSnapshotAudit, postAudit
} from '@/api/heritageCruise/unitSnapshot'
//import ViewLink from '@/components/viewLink.vue'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import hspGallery from '@/components/upload/gallery.vue'
import multiFile from '@/components/upload/multiFile.vue'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import FormDialog from '@/components/dialog/formDialog.vue'

const getHandleRules = (form: UnitSnapshotHandleData) => {
  return {
    HandleResult: [{ required: true, message: '请输入处理结果', trigger: 'blur' }]
  }
}
const getAuditRules = (form: UnitSnapshotAuditData) => {
  return {
    AuditResult: [{ required: true, validator: validateIntKey('请选择审核结果'), trigger: 'change' }]
  }
}
@Component({
  components: { FormDialog, hspGallery, multiFile }
})
export default class UnitSnapshotEvent extends Vue {
  public showDialog: boolean = false
  public loading: boolean = false
  public expandNames = ['handle']
  public act: string = 'handle'

  public form: UnitSnapshotData = Object.assign({}, emptyUnitSnapshot)
  public handleForm: UnitSnapshotHandleData = Object.assign({}, emptyUnitSnapshotHandle)
  public handleRules = getHandleRules(this.handleForm)
  public auditForm: UnitSnapshotAuditData = Object.assign({}, emptyUnitSnapshotAudit)
  public auditRules = getAuditRules(this.auditForm)
  public $refs!: {
    handleFormData: Element.Form
    auditFormData: Element.Form
  }
  public hasFile: boolean = true
  public onFileChange(data: { opts: UploadOptData; files: AttachInfo[] }) {
    const list = data.files
    this.hasFile = list.length > 0
  }
  public created() { }
  public mounted() {
    //act: handle/audit
    window.eventBus.$on('openUnitSnapshotEvent', (info: { id: number, act: string }) => {
      this.showDialog = true
      this.act = info.act
      if (this.act == 'handle') {
        this.expandNames = ['handle']
      }
      else {
        this.expandNames = ['viewHandle', 'audit']
      }
      this.fetchData(info.id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('openUnitSnapshotEvent')
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    getInfo(id)
      .then((response: { data: any }) => {
        this.form = response.data
        this.handleForm = this.form.EmptyHandle
        if (this.act == 'audit') {
          this.auditForm = this.form.EmptyAudit
        }
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  public onSubmit() {
    if (this.act == 'handle') {
      this.submitHandle()
    }
    else {
      this.submitAudit()
    }
  }
  public submitHandle() {
    this.$refs.handleFormData.validate((valid: boolean, obj: any) => {
      if (valid) {
        let f = Object.assign({}, this.handleForm)
        postHandle(f).then((response: { data: any }) => {
          const data = response.data
          if (data && !data.IsError) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.sendData(f)
            this.close()
          } else {
            this.$message({
              message: `提交失败,${data.Message}`,
              type: 'error'
            })
          }
        })
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
  public submitAudit() {
    this.$refs.auditFormData.validate((valid: boolean, obj: any) => {
      if (valid) {
        let f = Object.assign({}, this.auditForm)
        postAudit(f).then((response: { data: any }) => {
          const data = response.data
          if (data && !data.IsError) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.sendData(f)
            this.close()
          } else {
            this.$message({
              message: `提交失败,${data.Message}`,
              type: 'error'
            })
          }
        })
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
  public sendData(info: any) {
    window.eventBus.$emit('submitUnitSnapshotEvent', {
      data: info
    })
  }
  public close() {
    this.showDialog = false
    this.$refs.handleFormData.resetFields()
    this.$refs.auditFormData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
}
